
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const commonTranslationRef = createTranslationRef({
  id: 'app.common',
  messages: {
    button: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      close: 'Close',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      reset: 'Reset',
      apply: 'Apply',
      refresh: 'Refresh',
    },
    message: {
      error: {
        generic: 'An error occurred. Please try again.',
        networkError: 'Network error. Please check your connection.',
        unauthorized: 'You are not authorized to perform this action.',
        notFound: 'The requested resource was not found.',
        serverError: 'Server error. Please try again later.',
        timeout: 'Request timed out. Please try again.',
        badRequest: 'Invalid request. Please check your input.',
      },
      success: {
        saved: 'Changes saved successfully.',
        deleted: 'Item deleted successfully.',
        created: 'Item created successfully.',
        updated: 'Item updated successfully.',
        uploaded: 'File uploaded successfully.',
      },
    },
    state: {
      loading: {
        default: 'Loading...',
        data: 'Loading data...',
        page: 'Loading page...',
        content: 'Loading content...',
      },
      empty: {
        noData: 'No data available.',
        noResults: 'No results found.',
        noItems: 'No items to display.',
      },
    },
    label: {
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      actions: 'Actions',
      name: 'Name',
      description: 'Description',
      status: 'Status',
      type: 'Type',
      date: 'Date',
      owner: 'Owner',
    },
  },
});
